// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"ProFaqSection_faqSection__J9wnP","faqSectionTitle":"ProFaqSection_faqSectionTitle__ZXLLf","faqSectionContent":"ProFaqSection_faqSectionContent__2_vHK"};